module.exports = __webpack_public_path__ + "img/MUIC_Logo.e5c0e9e8.png";